import {
  AdminConversation,
  AdminPerson,
  UserType,
} from '@/shared/types/generated';
import { toDate } from './format';

const DAY_MS = 24 * 60 * 60 * 1000;
// Same cutoff as the overview's count on the server
export const STALE_DAYS = 30;

type Conversation = Pick<AdminConversation, 'lastMessageAt'> & {
  recipient: Pick<AdminPerson, 'type'>;
};

const ageInDays = (conversation: Pick<AdminConversation, 'lastMessageAt'>) =>
  (Date.now() - toDate(conversation.lastMessageAt).getTime()) / DAY_MS;

/** Unopened for over a day, but not so long it's history */
export const isWaiting = (conversation: Conversation) => {
  const days = ageInDays(conversation);
  return days > 1 && days <= STALE_DAYS;
};

export const isStale = (conversation: Conversation) =>
  ageInDays(conversation) > STALE_DAYS;

export const isNew = (conversation: Conversation) =>
  ageInDays(conversation) <= 1;

const ROLE_NAMES: Record<UserType, string> = {
  [UserType.Stylist]: 'stylist',
  [UserType.Client]: 'client',
};

export const roleName = (person: Pick<AdminPerson, 'type'>) =>
  person.type ? ROLE_NAMES[person.type] : 'user';

/**
 * A stylist leaving a client unread is the one to chase, so those come
 * first; oldest first within each group.
 */
export const byStylistsFirst = (a: Conversation, b: Conversation) =>
  Number(b.recipient.type === UserType.Stylist) -
    Number(a.recipient.type === UserType.Stylist) ||
  toDate(a.lastMessageAt).getTime() - toDate(b.lastMessageAt).getTime();
